import React from 'react'
import { TabConsumer } from '@cbgms/components/form/Tabs/TabItem'

const WithFormContext = <P extends {}>(WrappedComponent: React.ComponentType<P>) => {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component'

  class WithFormContext extends React.Component<P> {
    static displayName = `WithFormContext(${displayName})`
    static WrappedComponent = WrappedComponent

    render() {
      return <TabConsumer>{register => <WrappedComponent {...this.props} registerField={register} />}</TabConsumer>
    }
  }

  return WithFormContext
}

export default WithFormContext
